import { render, staticRenderFns } from "./TheFooterMobile.vue?vue&type=template&id=101ce5b9&scoped=true"
var script = {}
import style0 from "./TheFooterMobile.vue?vue&type=style&index=0&id=101ce5b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101ce5b9",
  null
  
)

export default component.exports